export default __webpack_public_path__ + "static/media/pencil.9283237e.png";